import { AssetCategoryWithElementsType } from './types';

// Carrier
const CARRIER_LABEL = 'Carrier';

const BACKPACK = 'Backpack';
const BRIEFCASE = 'Briefcase';
const LUGGAGE = 'Luggage';

const PROPS_CARRIER = ['Baby Stroller', BACKPACK, BRIEFCASE, LUGGAGE];
const PROPS_CARRIER_CATEGORY = {
  label: CARRIER_LABEL,
  list: PROPS_CARRIER,
};

const PROPS_CARRIER_UK = [BACKPACK, BRIEFCASE, LUGGAGE, 'Pram'];

const PROPS_CARRIER_CATEGORY_UK = {
  label: CARRIER_LABEL,
  list: PROPS_CARRIER_UK,
};

// Music
const PROPS_MUSIC = [
  'Bongos',
  'Instrument - Guitar',
  'Instrument - Keyboard',
  'Instrument - Marching Band',
  'Instrument - Orchestra',
];

const PROPS_MUSIC_CATEGORY = {
  label: 'Music',
  list: PROPS_MUSIC,
};

// Transportation
const PROPS_TRANSPORTATION = [
  'Bicycle - City',
  'Bicycle - Cruiser',
  'Bicycle - Mountain',
  'Bicycle - Other',
  'Moped Scooter',
  'Scooter',
  'Unicycle',
];

const PROPS_TRANSPORTATION_CATEGORY = {
  label: 'Transportation',
  list: PROPS_TRANSPORTATION,
};

// Sport

const SPORT_LABEL = 'Sport';

const BASEBALL_GLOVE = 'Baseball Glove';
const BOXING_GLOVES = 'Boxing Gloves';
const FRISBEE = 'Frisbee';
const GOLF_CLUBS = 'Golf Clubs';
const ICE_SKATES = 'Ice Skates';
const LONGBOARD = 'Longboard';
const POINTE_SHOES = 'Pointe Shoes';
const ROLLER_BLADES = 'Roller Blades';
const ROLLER_SKATES = 'Roller Skates';
const SKATEBOARD = 'Skateboard';
const SKIIS = 'Skiis';
const SNOWBOARD = 'Snowboard';
const SURFBOARD = 'Surfboard';
const WETSUIT = 'Wetsuit';
const YOGA_MAT = 'Yoga Mat';

const PROPS_SPORT = [
  BASEBALL_GLOVE,
  BOXING_GLOVES,
  FRISBEE,
  GOLF_CLUBS,
  ICE_SKATES,
  LONGBOARD,
  POINTE_SHOES,
  ROLLER_BLADES,
  ROLLER_SKATES,
  SKATEBOARD,
  SKIIS,
  SNOWBOARD,
  SURFBOARD,
  'Tennis Racket',
  WETSUIT,
  YOGA_MAT,
];

const PROPS_SPORT_CATEGORY = {
  label: SPORT_LABEL,
  list: PROPS_SPORT,
};

const PROPS_SPORT_UK = [
  BASEBALL_GLOVE,
  BOXING_GLOVES,
  FRISBEE,
  GOLF_CLUBS,
  ICE_SKATES,
  LONGBOARD,
  POINTE_SHOES,
  ROLLER_BLADES,
  ROLLER_SKATES,
  SKATEBOARD,
  SKIIS,
  SNOWBOARD,
  SURFBOARD,
  'Tennis Racquet',
  WETSUIT,
  YOGA_MAT,
];

const PROPS_SPORT_CATEGORY_UK = {
  label: SPORT_LABEL,
  list: PROPS_SPORT_UK,
};

// Other
const OTHER_LABEL = 'Other';

const CAMERA = 'Camera';
const DJ_EQUIPMENT = 'DJ Equipment';
const DOG = 'Dog';
const LAPTOP = 'Laptop';
const TACTICAL_BOOTS = 'Tactical Boots';

const PROPS_OTHER = [
  CAMERA,
  DJ_EQUIPMENT,
  DOG,
  LAPTOP,
  'Stenographer Machines',
  TACTICAL_BOOTS,
];

const PROPS_OTHER_UK = [
  CAMERA,
  DJ_EQUIPMENT,
  DOG,
  LAPTOP,
  'Stenograph Machines',
  TACTICAL_BOOTS,
];

const PROPS_OTHER_CATEGORY = {
  label: OTHER_LABEL,
  list: PROPS_OTHER,
};

const PROPS_OTHER_CATEGORY_UK = {
  label: OTHER_LABEL,
  list: PROPS_OTHER_UK,
};

const PROPS_CATEGORIES = [
  PROPS_CARRIER_CATEGORY,
  PROPS_MUSIC_CATEGORY,
  PROPS_TRANSPORTATION_CATEGORY,
  PROPS_SPORT_CATEGORY,
  PROPS_OTHER_CATEGORY,
];

const PROPS_CATEGORIES_UK = [
  PROPS_CARRIER_CATEGORY_UK,
  PROPS_MUSIC_CATEGORY,
  PROPS_TRANSPORTATION_CATEGORY,
  PROPS_SPORT_CATEGORY_UK,
  PROPS_OTHER_CATEGORY_UK,
];

export const PROPS_CATEGORIES_DETAILED: AssetCategoryWithElementsType[] =
  PROPS_CATEGORIES.map(({ label, list }) => ({
    label,
    list,
  }));

export const PROPS_CATEGORIES_DETAILED_UK: AssetCategoryWithElementsType[] =
  PROPS_CATEGORIES_UK.map(({ label, list }) => ({
    label,
    list,
  }));
